export default "__VITE_ASSET__6f6918f9__"